<div class="component-container xs:p-[2rem] sm:p-[1rem] md:p-[2.7rem]" style="position: relative;">

  <div *ngIf="retiring" class="retire-overlay">
    <mat-spinner></mat-spinner>
  </div>

  <!-- Filter Section -->
  <div class="filter-section">
    <div class="component-container flex flex-col md:flex-row flex-wrap justify-between items-center w-full">
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [enableClearSelection]="true"
        [options]="colorOptions"
        [parentFormGroup]="form"
        class="input w-full md:w-[15%]"
        controlName="color"
        label="Color"
        placeholder="All Colors"
        type="small"
      ></app-dropdown>

      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [enableClearSelection]="true"
        [options]="categoryOptions"
        [parentFormGroup]="form"
        class="input w-full md:w-[15%]"
        controlName="category"
        label="Category"
        placeholder="All Categories"
        type="small"
      ></app-dropdown>

      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [enableClearSelection]="true"
        [options]="statusOptions"
        [parentFormGroup]="form"
        class="input w-full md:w-[15%]"
        controlName="status"
        label="Status"
        placeholder="All Statuses"
        type="small"
      ></app-dropdown>

      <hr class="vertical hidden md:block">

      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        (handleSuffixClick)="apply()"
        [error]="errorMessages['search']"
        [parentFormGroup]="form"
        class="input w-full md:w-[25%] search-input"
        controlName="search"
        label="Search"
        placeholder="Search by name, terms, or FG ID"
        suffixIcon="search"
        type="small"
      ></app-text-input>

      <hr class="vertical hidden md:block">

      <app-primary-button
        (handleClick)="apply()"
        class="btn w-full md:w-[10%] md:mt-[1.5rem] mb-[1.5rem]"
        type="small"
      >
        Apply
      </app-primary-button>
    </div>
  </div>

  <!-- Table Section -->
  <div class="table-section">
    <mat-expansion-panel
      [expanded]="true"
      class="mat-elevation-z0 expansion-panel w-full"
    >
      <mat-expansion-panel-header class="bg-black-100 expansion-panel-header justify-center">
        <div class="title text-cool-grey font-poppins font-semibold text-[1.6rem]">
          Food Guide Items
        </div>
        <app-primary-button
          class="lg:w-[14%] xs:w-[35%] sm:w-[35%] md:w-[20%]"
          type="small"
          (handleClick)="openAddDialog(); $event.stopPropagation()"
          (click)="$event.stopPropagation()"
        >
          Add Food Item
        </app-primary-button>
      </mat-expansion-panel-header>

      <!-- Table with infinite scroll -->
      <div
        (scrolled)="onScroll()"
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="10"
        [scrollWindow]="false"
        class="table-wrapper overflow-auto xs:h-[calc(100vh-45rem)] sm:h-[calc(100vh-45rem)] md:h-[calc(100vh-30rem)]"
        infiniteScroll
      >
        <table
          (matSortChange)="sortData($event)"
          [class.hidden]="loading && isFirstPage"
          [dataSource]="dataSource"
          mat-table
          matSort
        >
          <!-- FG ID -->
          <ng-container matColumnDef="id">
            <th *matHeaderCellDef mat-header-cell mat-sort-header id="sort_fgId">
              <div class="th-cell">FG ID</div>
            </th>
            <td *matCellDef="let row" mat-cell class="w-[8rem] min-w-[8rem]">
              <div class="td-cell">{{row.fg_id || row.fgId || '-'}}</div>
            </td>
          </ng-container>

          <!-- Food Name -->
          <ng-container matColumnDef="name" [sticky]="true">
            <th *matHeaderCellDef mat-header-cell mat-sort-header id="sort_name">
              <div class="th-cell">Food Name</div>
            </th>
            <td *matCellDef="let row" mat-cell class="w-[20rem] min-w-[20rem]">
              <div class="td-cell">{{row.name}}</div>
            </td>
          </ng-container>

          <!-- Color -->
          <ng-container matColumnDef="color">
            <th *matHeaderCellDef mat-header-cell>
              <div class="th-cell">Color</div>
            </th>
            <td *matCellDef="let row" mat-cell class="w-[10rem] min-w-[10rem]">
              <div class="flex flex-row gap-[1rem] td-cell items-center">
                <div
                  [ngStyle]="{'background-color': colorIndicators[row.color]}"
                  class="indicator"
                ></div>
                <div class="text">{{row.color}}</div>
              </div>
            </td>
          </ng-container>

          <!-- Category -->
          <ng-container matColumnDef="category">
            <th *matHeaderCellDef mat-header-cell>
              <div class="th-cell">Category</div>
            </th>
            <td *matCellDef="let row" mat-cell class="w-[16rem] min-w-[16rem]">
              <div class="td-cell">{{categoryMap[row.category] || '-'}}</div>
            </td>
          </ng-container>

          <!-- Serving Size -->
          <ng-container matColumnDef="servingSize">
            <th *matHeaderCellDef mat-header-cell>
              <div class="th-cell">Serving Size</div>
            </th>
            <td *matCellDef="let row" mat-cell class="w-[12rem] min-w-[12rem]">
              <div class="td-cell">{{row.servingAmount}} {{row.servingUnit}}</div>
            </td>
          </ng-container>

          <!-- Search Terms -->
          <ng-container matColumnDef="searchTerms">
            <th *matHeaderCellDef mat-header-cell>
              <div class="th-cell">Search Terms</div>
            </th>
            <td *matCellDef="let row" mat-cell class="w-[18rem] min-w-[18rem]">
              <div class="td-cell">{{row.searchTerms || '-'}}</div>
            </td>
          </ng-container>

          <!-- Status -->
          <ng-container matColumnDef="isActive">
            <th *matHeaderCellDef mat-header-cell>
              <div class="th-cell">Status</div>
            </th>
            <td *matCellDef="let row" mat-cell class="w-[10rem] min-w-[10rem]">
              <div class="flex flex-row gap-[1rem] td-cell items-center">
                <div
                  [ngStyle]="{'background-color': row.isActive ? '#28A745' : '#6C757D'}"
                  class="indicator"
                ></div>
                <div class="text">{{row.isActive ? 'Active' : 'Retired'}}</div>
              </div>
            </td>
          </ng-container>

          <!-- Updated Date -->
          <ng-container matColumnDef="updatedAt">
            <th *matHeaderCellDef mat-header-cell mat-sort-header id="sort_updatedAt">
              <div class="th-cell">Updated</div>
            </th>
            <td *matCellDef="let row" mat-cell class="w-[12rem] min-w-[12rem]">
              <div class="td-cell">{{(row.updatedAt || row.updated_at) | date:'MM/dd/YYYY'}}</div>
            </td>
          </ng-container>

          <!-- Action Menu -->
          <ng-container matColumnDef="actionMenu">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let row" mat-cell class="w-[2rem]">
              <button [matMenuTriggerFor]="menu" mat-icon-button>
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="openEditDialog(row)">
                  <mat-icon>edit</mat-icon>
                  <span class="display-name">Edit</span>
                </button>
                <button mat-menu-item (click)="openAuditDialog(row)">
                  <mat-icon>history</mat-icon>
                  <span class="display-name">View History</span>
                </button>
                <button mat-menu-item (click)="retireItem(row)" *ngIf="row.isActive">
                  <mat-icon>archive</mat-icon>
                  <span class="display-name">Retire</span>
                </button>
                <button mat-menu-item (click)="unretireItem(row)" *ngIf="!row.isActive">
                  <mat-icon>unarchive</mat-icon>
                  <span class="display-name">Unretire</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
          <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
        </table>

        <div *ngIf="loading"
             [ngClass]="{'initial': isFirstPage}"
             class="table-loader w-full flex justify-center items-center">
          <mat-spinner/>
        </div>

        <div
          *ngIf="!loading && !dataSource.data?.length"
          class="no-data flex flex-col justify-center items-center"
        >
          <div class="text">
            No food items found.
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </div>
</div>
